import React from "react";
import {useCreateTeacherForm} from "../../hook/useCreateTeacherForm";
import {Option} from "common/form/autoComplete/_option";
import {STATUS_TEACHER} from "../../interfaces/constant";
import {AlternativeAutoComplete} from "../../../../../../common/form/autoComplete/_alternativeAutoComplete";

export const StatusPerson = ()=>{
    const {statusPerson} = useCreateTeacherForm()
    const {methods} = statusPerson
    return (
        <AlternativeAutoComplete
            // main input
            inputProps={{
                categoryList: [], // menu list in category dropdown
                categoryHidden: true,
                readOnly: true,
                categoryValue: { name: 'Vui lòng chọn trạng thái', value: '' },
                label: 'Trạng thái',
                placeholder: 'Vui lòng chọn trạng thái',
                value: statusPerson?.value?.title,
            }}
            hideSearchBar={true}
            // search input in dropdown menu
            menuProps={{
                empty: '',
            }}
            // search input in dropdown menu
            validateText={statusPerson?.message}
            validateType={statusPerson?.status ? 'danger' : 'success'}
        >
            {
                STATUS_TEACHER?.map((item, index) => (
                    <Option
                        key={index}
                        className="teacher__option-text"
                        data-active={statusPerson?.value?.value === item.value}
                        onClick={() => methods.onChange(item)}
                        style={{marginTop: 16, cursor:'pointer'}}
                    >
                        {item.title}
                    </Option>
                ))}
        </AlternativeAutoComplete>
    )
}